// models/brand
import ES6 from 'es6-promise'
ES6.polyfill()
import 'isomorphic-fetch'
import config from '../../config/public'
import merge from 'merge'

export default {
  get(params, callback) {
    const endpoint = `${config.rechat_host}/brands/${params.id}`
    fetch(endpoint, {
      method: 'get',
      headers: {
        'Content-Type': 'application/json'
      }
    })
    .then(response => {
      if (response.status >= 400) {
        return callback(response, null)
      }
      return response.json()
    })
    .then(response => {
      return callback(null, response)
    })
  },

  flatten(brand) {
    const brands = [brand]
    while(brand.parent) {
      brands.push(brand.parent)
      brand = brand.parent
    }

    brands.reverse()

    let merged = {}

    brands.forEach(brand => {
      brand.parent = undefined
      merge.recursive(merged, brand)
    })

    return merged
  },

  color(name, def, brand) {
    if (!brand) {
      return def
    }

    do {
      const palette = brand.palette

      if (palette && palette[name]) {
        return palette[name]
      }

      brand = brand.parent
    } while (brand)

    return def
  }
}


// WEBPACK FOOTER //
// ./src/models/Brand.js